import React from "react";
import PropTypes from "prop-types";
import { Popover, PopoverBody } from "reactstrap";

import { defaultOptions } from "../../../helpers/popoverOptions";

import "./styles.scss";

export default function Popper(props) {
  const { children, popperOptions } = props;

  return (
    <Popover {...defaultOptions} {...popperOptions}>
      <PopoverBody>{children}</PopoverBody>
    </Popover>
  );
}

Popper.propTypes = {
  popperOptions: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired
};
